import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Mihai Cristian",
    stars: 5,
    text:
      "Foarte serios și punctual. A venit la ora stabilită, a lucrat curat și a terminat totul mai repede decât mă așteptam. Recomand cu încredere!",
  },
  {
    name: "Cristina Raluca",
    stars: 5,
    text:
      "Am apelat la el pentru o lucrare de renovare și am fost foarte mulțumit. Explică fiecare pas, oferă soluții bune și folosește materiale de calitate. Cu siguranță voi mai colabora.",
  },
  {
    name: "Andrei Dinu",
    stars: 5,
    text:
      "Raport calitate-preț foarte bun. Lucrarea a ieșit exact cum am discutat, fără întârzieri și fără costuri ascunse. Un meșter de încredere, recomand tuturor.",
  },
];

export default function Reviews() {
  const [idx, setIdx] = useState(0);
  const prev = () => setIdx((i) => (i - 1 + REVIEWS.length) % REVIEWS.length);
  const next = () => setIdx((i) => (i + 1) % REVIEWS.length);

  const r = REVIEWS[idx];

  return (
    <section
      id="recenzii"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-[var(--bg-elevated)]"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 reveal">
          <div className="max-w-xl">
            <div className="eyebrow mb-5">
              <span>Recenzii clienți</span>
            </div>
            <h2 className="font-display text-[var(--text-primary)] text-4xl md:text-5xl leading-[1.08] font-medium">
              Ce spun cei cu care am{" "}
              <span className="text-brand-blue italic">lucrat</span>.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              data-testid="reviews-prev"
              className="h-12 w-12 rounded-full border border-[var(--border-mid)] hover:border-[var(--brand-gold)] hover:text-[var(--brand-gold)] text-[var(--text-primary)] flex items-center justify-center transition-colors focus-ring"
              aria-label="Recenzia anterioară"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={next}
              data-testid="reviews-next"
              className="h-12 w-12 rounded-full border border-[var(--border-mid)] hover:border-[var(--brand-gold)] hover:text-[var(--brand-gold)] text-[var(--text-primary)] flex items-center justify-center transition-colors focus-ring"
              aria-label="Recenzia următoare"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="mt-12 reveal">
          <article
            key={idx}
            data-testid="review-card"
            className="relative rounded-2xl border border-[var(--border-subtle)] bg-[var(--bg-card)] p-8 md:p-14 overflow-hidden"
          >
            <Quote
              className="absolute top-8 right-8 h-24 w-24 md:h-32 md:w-32 text-[rgba(30,95,217,0.10)]"
              strokeWidth={1}
            />

            <div
              className="flex items-center gap-1 text-2xl star"
              data-testid="review-stars"
              aria-label={`${r.stars} din 5 stele`}
            >
              {Array.from({ length: r.stars }).map((_, i) => (
                <span key={i}>★</span>
              ))}
            </div>

            <blockquote
              data-testid="review-text"
              className="mt-8 font-display text-[var(--text-primary)] text-xl md:text-3xl leading-[1.35] font-normal max-w-3xl"
            >
              „{r.text}”
            </blockquote>

            <footer className="mt-10 flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-brand-blue/15 border border-brand-blue/50 flex items-center justify-center text-brand-blue font-display text-lg font-semibold">
                {r.name.split(" ").map((n) => n[0]).join("")}
              </div>
              <div>
                <div
                  data-testid="review-name"
                  className="font-display text-lg text-[var(--text-primary)] font-medium"
                >
                  {r.name}
                </div>
                <div className="text-xs uppercase tracking-[0.18em] text-[var(--text-muted)] mt-1">
                  Client verificat
                </div>
              </div>
            </footer>

            <div className="mt-10 flex items-center gap-2">
              {REVIEWS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  data-testid={`review-dot-${i}`}
                  aria-label={`Recenzia ${i + 1}`}
                  className={`h-1.5 rounded-full transition-all ${
                    i === idx
                      ? "w-8 bg-[var(--brand-gold)]"
                      : "w-3 bg-black/15 hover:bg-black/30"
                  }`}
                />
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
